<ng-container *ngIf="show">
  <div [ngClass]="{ shadow: shadow }">
    <div [ngClass]="[shadow ? 'shadow-spinner' : 'spinner']">
      <mat-progress-spinner
        id="spinner"
        aria-label="Loading"
        color="primary"
        [mode]="mode"
        [value]="value"
        diameter="50"
      >
      </mat-progress-spinner>
      <div *ngIf="value !== null" class="percent">{{ value }}%</div>
    </div>
  </div>
</ng-container>
